/**
 * Constants for localStorage and sessionStorage keys
 * Centralizes storage key definitions to prevent typos and improve maintainability
 */

/**
 * LocalStorage keys used throughout the application
 */
export const LOCAL_STORAGE_KEYS = {
  /** Current application language (e.g., 'en', 'es', 'ar') */
  LANGUAGE: 'language',

  /** List of files that have been started but not completed */
  STARTED_FILES: 'startedFiles',

  /** Currently selected service categories for filtering */
  CURRENT_SERVICE_CATEGORIES: 'currentServiceCategories'
} as const;

/**
 * SessionStorage keys used for authentication and navigation
 */
export const SESSION_STORAGE_KEYS = {
  /** CAS authentication state for CSRF protection */
  CAS_AUTH_STATE: 'casAuthState',

  /** URL to redirect to after login completes */
  POST_LOGIN_REDIRECT: 'postLoginRedirect',

  /** Flag indicating CAS auto-login has been attempted */
  CAS_AUTOLOGIN_ATTEMPTED: 'CAS_AUTOLOGIN_ATTEMPTED'
} as const;
